import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({ providedIn: 'root' })
export class IntegratorTemplateDownloadService {
  private started = false;

  constructor(
    private readonly http: HttpClient,
    private readonly message: NzMessageService
  ) {}

  start(): void {
    if (this.started) return;

    this.started = true;
    document.addEventListener('click', event => {
      const anchor = (event.target as HTMLElement).closest<HTMLAnchorElement>(
        'a[data-integrator-sample]'
      );
      if (!anchor) return;

      event.preventDefault();
      this.download(anchor.dataset['integratorSample'] ?? '');
    });
  }

  download(type: string): void {
    this.http
      .get('api/QNEIntegrator/DownloadSample', {
        params: { type },
        observe: 'response',
        responseType: 'blob'
      })
      .subscribe({
        next: response =>
          saveAs(
            response.body!,
            this.fileName(response.headers.get('Content-Disposition'))
          ),
        error: () =>
          this.message.error('Unable to download the integrator template.')
      });
  }

  private fileName(contentDisposition: string | null): string {
    const header = contentDisposition ?? '';
    const encoded = /filename\*=(?:UTF-8''|utf-8'')([^;]+)/i.exec(header);
    if (encoded) {
      return decodeURIComponent(encoded[1].trim().replace(/"/g, ''));
    }

    const plain = /filename="?([^";]+)"?/i.exec(header);
    return plain ? plain[1].trim() : 'integrator-template.csv';
  }
}
